import React from 'react';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const IconPlus = React.forwardRef<SVGSVGElement, any>((props, ref) => {
  return (<svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="icon-plus" data-icon="icon-plus" aria-hidden="true" {...props} ref={ref}><line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/></svg>);
});

IconPlus.displayName = 'IconPlus';
